import React, { useState, useRef } from "react";
import { Link } from 'react-router-dom';
import Typist from "react-typist";
import IconButton from '@material-ui/core/IconButton';
import ExpandMoreOutlinedIcon from '@material-ui/icons/ExpandMoreOutlined';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import Configs from "../../Assets/editable-stuff/configurations.json";
import "../../App";
import {scroller} from 'react-scroll';
import Seo from "../Seo";


const scrollFunc=(e)=>{
    scroller.scrollTo(e, {
      duration: 1400,
      delay: 0,
      offset: 25,
      smooth: 'easeInOutQuart'
    })
}


const MainHeader = () => {

  const [devInfo] = useState(Configs.devIntro);
  const [devDesc] = useState(Configs.devDesc);
  const icons = Configs.icons;
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);
  const videoRef = useRef(null);

  const handlePlayVideo = () => {
    if (videoRef.current) {
      videoRef.current.play();
      setIsVideoPlaying(true);
    }
  };

  const [hoverstatus, setHoverstatus] = useState([
    "socialicons",
    "socialicons",
    "socialicons",
    "socialicons",
    "socialicons"
  ]);

  const toggleHover = data => {
    const newhoverStatus = [...hoverstatus];

    if (data.event === "enter") {
      newhoverStatus[data.icon.id] = "socialiconshover";
      return setHoverstatus(newhoverStatus);
    } else if (data.event === "leave") {
      newhoverStatus[data.icon.id] = "socialicons";
      return setHoverstatus(newhoverStatus);
    }
  };

  const services = [
    { name: "Information Technology", path: "/it", icon: "💻" },
    { name: "Websites & Apps", path: "/web-app", icon: "🌐" },
    { name: "Automation", path: "/automation", icon: "⚡" }
  ];
  const structuredData = [
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: "NeedForGeeks",
      url: "https://www.needforgeeks.com/",
    },
    {
      "@context": "https://schema.org",
      "@type": "ProfessionalService",
      name: "NeedForGeeks",
      url: "https://www.needforgeeks.com/",
      telephone: "+19293304724",
      email: "info@needforgeeks.com",
      areaServed: "New York, NY",
      description:
        "NeedForGeeks provides IT support, website and app development, and business automation services for homes and businesses in New York.",
      makesOffer: services.map((service) => ({
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: service.name,
        },
      })),
    },
  ];

  return (
    <div>
      <Seo
        title="NeedForGeeks — New York Tech Services: IT, Web & App, Automation"
        description="NeedForGeeks is a New York tech services team handling IT support, website & app development, and business automation. Talk to a real person and get a quote fast."
        path="/"
        keywords="New York tech services, IT support New York, website development New York, app development New York, business automation New York"
        structuredData={structuredData}
      />

      {/* Modern Split Hero Section */}
      <div className="hero-modern">
        {/* Left Content Side */}
        <div className="hero-content-side">
          <div className="hero-badge">
            <span className="badge-dot"></span>
            Professional Tech Services
          </div>

          <h1 className="hero-title-modern">{devInfo}</h1>

          <div className="hero-typing">
            <Typist
              cursor={{ show: true, blink: true, element: '|' }}
              avgTypingDelay={50}
            >
              {devDesc}
            </Typist>
          </div>

          <div className="hero-social-row">
            {icons.map(icon => (
              <a
                key={icon.id}
                target="_blank"
                rel="noopener noreferrer"
                href={icon.url}
                aria-label={`My ${icon.image.split("-")[1]}`}
                className="hero-social-link"
              >
                <i
                  className={`fab ${icon.image} fa-lg ${hoverstatus[icon.id]}`}
                  onMouseOver={() => toggleHover({ icon, event: "enter" })}
                  onMouseOut={() => toggleHover({ icon, event: "leave" })}
                />
              </a>
            ))}
          </div>
        </div>

        {/* Right Services Side */}
        <div className="hero-services-side">
          <div className="services-grid">
            {services.map((service, index) => (
              <Link
                key={index}
                to={service.path}
                className="service-card-hero"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <span className="service-icon">{service.icon}</span>
                <span className="service-name">{service.name}</span>
                <span className="service-arrow">→</span>
              </Link>
            ))}
          </div>

          <div className="hero-stats">
            <div className="stat-item">
              <span className="stat-number">5+</span>
              <span className="stat-label">Years Experience</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">500+</span>
              <span className="stat-label">Happy Clients</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">24/7</span>
              <span className="stat-label">Support</span>
            </div>
          </div>
        </div>

        {/* Scroll Indicator */}
        <IconButton
          onClick={()=>scrollFunc("video-showcase")}
          className="scroll-indicator"
        >
          <ExpandMoreOutlinedIcon style={{color: "white", fontSize: "32px"}} />
        </IconButton>

        {/* Background Elements */}
        <div className="hero-bg-gradient"></div>
        <div className="hero-bg-orb hero-bg-orb-1"></div>
        <div className="hero-bg-orb hero-bg-orb-2"></div>
      </div>

      {/* Video Showcase Section */}
      <section id="video-showcase" className="video-showcase-section">
        <div className="video-showcase-container">
          <div className="video-header">
            <span className="video-label">See What We Do</span>
            <h2 className="video-title">Your Tech Problems, Solved</h2>
            <p className="video-subtitle">
              Watch how we help businesses and individuals with their technology needs
            </p>
          </div>

          <div className="video-wrapper">
            <video
              ref={videoRef}
              className="showcase-video"
              controls
              playsInline
              onPlay={() => setIsVideoPlaying(true)}
              onPause={() => setIsVideoPlaying(false)}
              onEnded={() => setIsVideoPlaying(false)}
            >
              <source src="/NeedForGeeks_Overview.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>

            {/* Play Button Overlay */}
            {!isVideoPlaying && (
              <div className="video-play-overlay" onClick={handlePlayVideo}>
                <div className="play-button">
                  <PlayArrowIcon style={{ fontSize: '4rem', color: '#0f172a' }} />
                </div>
                <span className="play-text">Watch Video</span>
              </div>
            )}

            <div className="video-glow"></div>
          </div>
        </div>
      </section>
    </div>

  );

};

export default MainHeader;
